import React from "react";
import AppRoutes from "./routes/Routes";

const App = () => {
  return (
    <div>
      <AppRoutes />
    </div>
  );
};

export default App;
